<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''">
    
    <!-- <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary'>
      <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>
      <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red'>
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>
      <span>{{ alert_err_attention }}</span>
    </v-snackbar> -->

    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>

   
    
    <!-- <v-layout row wrap class="mt-4 mx-0">
      <v-flex sm12 xs12 md12 lg12> -->

        <v-card class="mx-auto ml-2 mr-2 mb-4" max-width="100%" outlined> 
          <v-card-title class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
            <v-icon small class="mr-4" color="black">mdi-laptop</v-icon> Update User
          </v-card-title>
          
          <v-list-item-content>
                <v-form v-model="valid" ref="form">
                  <!-- <v-container> -->
                  <v-card-text>

                    <v-row>
                      <!-- Left Column: Update Form -->
                      <v-col cols="12" md="8">





                        
                        <h4 class="my-4" style="color: #0471A5;">User Information</h4>
                        <v-divider></v-divider>
                        <v-row class="mt-4">



                          <v-col cols="12" md="4">
                            <v-text-field dense
                              prepend-inner-icon="mdi-format-text-variant"
                              outlined
                              v-model="inputedItem.nik"
                              :rules="nikrules"
                              hint="Write NIK(Nomor Induk Kepegawaian) *harus diisi"
                              label="NIK"
                              required
                              persistent-hint
                            ></v-text-field>

                          </v-col>

                          <v-col cols="12" md="4">
                            <v-text-field dense
                              prepend-inner-icon="mdi-format-text-variant"
                              outlined
                              v-model="inputedItem.fullname"
                              hint="Write user fullname *harus diisi"
                              label="Fullname"
                              :rules="fullnamerules"
                              required
                              persistent-hint
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field dense
                              prepend-inner-icon="mdi-office-building-outline"
                              outlined
                              v-model="inputedItem.departement"
                              :rules="departementrules"
                              hint="Nama Departement"
                              label="Nama Departement"
                              required
                              persistent-hint
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <h4 class="my-4" style="color: #0471A5;">User Account Data</h4>
                        <v-divider></v-divider>
                        <v-row class="mt-4">
                          <v-col cols="12" md="4">
                            <v-text-field dense
                              prepend-inner-icon="mdi-account"
                              outlined
                              v-model="inputedItem.username"
                              :rules="usernamerules"
                              hint="Write user login account *harus diisi"
                              label="Username"
                              required
                              persistent-hint
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="4">
                            <v-text-field dense
                              outlined
                              v-model="inputedItem.password"
                              :append-icon="showpassword ? 'mdi-eye' :'mdi-eye-off'"
                              :type="showpassword ? 'text' : 'password'"
                              name="input-10-1"
                              label="Password"
                              hint="Set user password, Password merupakan kombinisi huruf dan angka *harus diisi"
                              persistent-hint
                              required
                              @click:append="showpassword = !showpassword"
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <h4 class="my-4" style="color: #0471A5;">Connectivity</h4>
                        <v-divider></v-divider>
                        <v-row class="mt-4">
                          
                          <v-col cols="12" md="4">
                            <v-text-field dense
                              prepend-inner-icon="mdi-phone"
                              outlined
                              v-model="inputedItem.mobile"
                              hint="Write user mobile phone"
                              :rules="mobilerules"
                              label="Phone"
                              required
                              persistent-hint
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" md="4">
                            <v-text-field dense
                              prepend-inner-icon="mdi-email"
                              outlined
                              v-model="inputedItem.email"
                              hint="Write user email account"
                              label="E-mail"
                              :rules="emailrole"
                              required
                              persistent-hint
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field dense
                              prepend-inner-icon="mdi-skype"
                              outlined
                              v-model="inputedItem.skype_id"
                              hint="Write Skype ID/account"
                              label="Skype ID"
                              required
                              persistent-hint
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row class="mt-4">

                          <v-col cols="12" md="4">
                            <v-text-field dense
                              prepend-inner-icon="mdi-google"
                              outlined
                              v-model="inputedItem.google_id"
                              hint="Write User google account"
                              label="Google ID"
                              required
                              persistent-hint
                            ></v-text-field>
                          </v-col>
                        </v-row>











                        <!-- Additional Input Fields... -->
                      </v-col>
                      
                      <!-- Right Column: Profile Info with Image -->
                      <v-col cols="12" md="4">
                        <v-card class="profile-card" elevation="3" outlined style="padding: 16px; margin: 0;">
                          <v-card-title class="d-flex flex-column align-center">
                            <v-avatar size="120" class="mb-4">
                              <!-- Show icon if profileImageUrl is empty -->
                              <v-icon v-if="!profileImageUrl" size="80">mdi-account-circle</v-icon>
                              <img v-else :src="profileImageUrl" alt="User Image">
                            </v-avatar>
                            <h4>{{ inputedItem.fullname }}</h4>
                            <span>{{ inputedItem.departement }}</span>
                          </v-card-title>
                          <v-card-text>
                            <p><strong>Email:</strong> {{ inputedItem.email }}</p>
                            <p><strong>Phone:</strong> {{ inputedItem.mobile }}</p>
                            <p><strong>Skype ID:</strong> {{ inputedItem.skype_id }}</p>
                            <p><strong>Google ID:</strong> {{ inputedItem.google_id }}</p>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-divider class="mt-4"></v-divider>
                    <v-card-actions class="align-center justify-center">
                      <v-btn rounded class="my-3" color="primary" :loading="btnload" @click="validate" dark>
                        Save 
                        <v-icon class="mx-2">mdi-content-save</v-icon>
                      </v-btn>
                    </v-card-actions>
                  <!-- </v-container> -->
                  </v-card-text>

                </v-form>
            
          </v-list-item-content>
        </v-card>

      <!-- </v-flex>
    </v-layout> -->
    
    <Notification ref="alert"></Notification>
  </div>
</template>


<script>
import Notification from  '@/components/Notification';
import { decryptionData } from '@/components/utils/utils.js';
import axios from "axios";
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
        btnload:false,
        showpassword: false,
        nikrules: [
          v => !!v || 'Nik is required',
          v => (!isNaN(parseFloat(v)) && v >= 0 ) || 'Nik must be less than number',//validasi nuber
          v => (v && v.length >= 16) || 'Nik minimum 16 characters',

        ],
        fullnamerules: [
          v => !!v || 'Fullname is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
        ],
        departementrules: [
          v => /^[\w\s]+$/.test(v) || 'Input must only contain alphabets, numeric and space',
        ],
        usernamerules: [
          v => /^[\w\s]+$/.test(v) || 'Input must only contain alphabets, numeric and space',
        ],
        
        mobilerules: [
          v => (!isNaN(parseFloat(v)) && v >= 0 ) || 'Input must be less than number',//validasi nuber
          v => (v && v.length <= 13) || 'Input maximum 13 characters',
        ],
        emailrole: [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],
        expanded: [],
        singleExpand: false,
        page: [
        {
          text: 'Profile',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Edit',
          disabled: true,
          href: 'breadcrumbs_link_1',
        },
      ],
      
      inputedItem: {

      },
      valid:'',
      user_id:'',
      username_lama: '',
      // password_lama: '',
      // date: new Date().toISOString().substr(0, 10),
     
      // itemsSelectTable: ['10 GB', '20 GB', '60 GB'],
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
    
    }),
    computed: {
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
    },
    watch: {

    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        axios({
          method: "get",
          url: "/profile-id",
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data; 
            const dat = decryptionData(response.data.token);
            this.user_id =dat.USER_ID; 
            // this.password_lama =dat.PASS; 
            this.username_lama =dat.USERNAME; 
            this.inputedItem = {
              nik:dat.NIK,
              fullname:dat.FULLNAME,
              departement:dat.DEPARTMENT_NAME,
              username:dat.USERNAME,
              password:dat.PASS,
              mobile:dat.MOBILE,
              email:dat.EMAIL,
              skype_id:dat.SKYPE_ID,
              google_id:dat.GOOGLE_ID
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
  
       validate () {
        
        const  valid  = this.$refs.form.validate()

        if (valid) {
          this.btnload = true
          axios.put("/profile-update", 
            {
              user_id:this.user_id,
              nik:this.inputedItem.nik,
              fullname:this.inputedItem.fullname,
              departement_name:this.inputedItem.departement,
              username:this.inputedItem.username,
              username_lama:this.username_lama,
              password:this.inputedItem.password,
              // password_lama:this.password_lama,
              mobile:this.inputedItem.mobile,
              email:this.inputedItem.email,
              skype_id:this.inputedItem.skype_id,
              google_id:this.inputedItem.google_id
            },
            
            {headers:{'auth-token':localStorage.getItem('token_app')}},
            {dataType: 'json'}
            )
          .then((response) => {
              this.initialize()
              // alert('okk');      
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
              } 
              // this.$router.push('/profile');
              
              let nik = JSON.parse(localStorage.getItem('nik'));
              if(nik == null){
                let tmp_menu = (localStorage.getItem('tmpmenuPrivilage'));
                localStorage.setItem("nik",this.inputedItem.nik)//mengirim token ke local storage
                localStorage.setItem("menuPrivilage", tmp_menu)//mengirim token ke local storage
                this.$router.go('/profile');
                
              }else{
                this.btnload = false
                this.$router.push('/profile');
              }
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
              this.btnload = false

          });
        }
      },
    },
  }
</script>